module.exports = __webpack_public_path__ + "img/9788949120942.3e31c2d2.jpg";